import { Request } from '@/classes/Request'

// POST /ajax/account_settings/mcp/connections/{connectionId}/disconnect
export const disconnectMcpConnection = async (connectionId: number): Promise<void> => {
  await new Request().post(`/ajax/account_settings/mcp/connections/${connectionId}/disconnect`, {})
}
